import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-tooltip@3.7.3@rc-tooltip/es/index.js
// module id = 1410
// module chunks = 0